import {
  ShoppingCartItem,
  ShoppingCartItemCreate,
  shoppingCartItemsSchema,
  ShoppingCartItemUpdate,
} from "@mjolnerbacken/shared/types/shopping-cart-item";

import { deleteRequest, getRequest, postRequest } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getShoppingCartItems(): Promise<ShoppingCartItem[]> {
  return await getRequest(
    `${API_BASE_URL}/shopping-cart-items`,
    shoppingCartItemsSchema,
  );
}

export async function createShoppingCartItem(
  create: ShoppingCartItemCreate,
): Promise<void> {
  await postRequest(`${API_BASE_URL}/shopping-cart-items`, create);
}

export async function updateShoppingCartItem(
  id: string,
  update: ShoppingCartItemUpdate,
): Promise<void> {
  await postRequest(`${API_BASE_URL}/shopping-cart-items/${id}`, update);
}

export async function deleteShoppingCartItem(id: string): Promise<void> {
  await deleteRequest(`${API_BASE_URL}/shopping-cart-items/${id}`);
}
